export default {
    containers: [],
    init() {
        this.containers = document.querySelectorAll('[data-sticky]');
        if (!this.containers) {
            return;
        }

        const media = document.querySelectorAll('[data-sticky-media]');
        const text  = document.querySelectorAll('[data-sticky-text]');

        for (let i = 0; i < media.length; i++) {
            media[i].style.zIndex = i + 1;
        }
        
        document.addEventListener('scroll', () => {
            const viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
            for (const textElement of text) {
                if (textElement.getBoundingClientRect().top < viewportHeight) {
                    const mediaId = textElement.dataset.stickyText;
                    for (const mediaElement of media) {
                        if (!mediaElement.previousElementSibling || mediaElement.dataset.stickyMedia === mediaId) {
                            mediaElement.style.opacity = '1';
                        } else {
                            mediaElement.style.opacity = '0';
                        }
                    }
                }
            }
        });
    }
}